export const trimAfter = (str, threshold) => str.length > threshold ? "".concat(str.substring(0, threshold), "...") : str;
export const pluralize = (word, count, inclusive, pluralWord) => {
  const finalPluralWord = pluralWord ? pluralWord : "".concat(word, "s");
  const finalWord = count === 1 ? word : finalPluralWord;
  return inclusive ? "".concat(count, " ").concat(finalWord) : finalWord;
};
/**
 * Given a value, try parsing the value as JSON and return the result of the parsing as an
 * object, or return null without throwing an error.
 * @param {any} jsonString An input string which may or may not be JSON
 */
export function tryParseJSON(maybeJSON) {
  if (typeof maybeJSON !== 'string') {
    return {
      success: false,
      result: null
    };
  }
  try {
    const json = JSON.parse(maybeJSON);
    return {
      success: true,
      result: json
    };
  } catch (_unused) {
    return {
      success: false,
      result: null
    };
  }
}
export const removeDuplicates = arr => {
  return arr.filter((item, index) => arr.indexOf(item) === index);
};